import { useEffect, useRef, useState } from 'react';

import { Drawer } from '../Drawer';
import { Modal } from '../Modal';

import { DetailsModalProps } from './DetailsModal.types';

export const DetailsModal = <TItem, TProps extends object>({
  selectedItem: _selectedItem,
  setSelectedItem: _setSelectedItem,
  DetailsComponent,
  type,
  size,
  className,
  disableBackdropClick,
  disableEscapeKey,
  disableCloseButton,
  ...props
}: DetailsModalProps<TItem, TProps>) => {
  const [selectedItem, setSelectedItem] = useState(_selectedItem);
  const waitingRef = useRef(false);

  useEffect(() => {
    if (_selectedItem) {
      waitingRef.current = false;
      setSelectedItem(_selectedItem);
    } else {
      waitingRef.current = true;
      setTimeout(() => {
        if (waitingRef.current) {
          setSelectedItem(undefined);
          waitingRef.current = false;
        }
      }, 500);
    }
  }, [_selectedItem, setSelectedItem]);

  return type === 'drawer' ? (
    <Drawer
      size={size}
      open={Boolean(_selectedItem)}
      onClose={() => _setSelectedItem(undefined)}
      className={className}
      disableBackdropClick={disableBackdropClick}
      disableEscapeKey={disableEscapeKey}
      disableCloseButton={disableCloseButton}
    >
      {selectedItem !== undefined && (
        <DetailsComponent
          item={selectedItem}
          close={() => _setSelectedItem(undefined)}
          {...(props as TProps)}
        />
      )}
    </Drawer>
  ) : (
    <Modal
      open={Boolean(_selectedItem)}
      onClose={() => _setSelectedItem(undefined)}
      size={size}
      className={className}
      disableBackdropClick={disableBackdropClick}
      disableEscapeKey={disableEscapeKey}
      disableCloseButton={disableCloseButton}
    >
      {selectedItem !== undefined && (
        <DetailsComponent
          item={selectedItem}
          close={() => _setSelectedItem(undefined)}
          {...(props as TProps)}
        />
      )}
    </Modal>
  );
};
